import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_SETUP_BY_SCHOOL_ID } from "../apiRoutes";

export interface LabSetupDetailsApi {
  _id: string;
  schoolId: string;
  targetDate?: string;
  noOfWorkstations?: number;
  specialRequirements?: string;
  labSetupStatus?: string;
  comment?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface GetLabSetupResponse {
  data?: {
    labSetupDetails?: LabSetupDetailsApi;
    comments?: any[];
  };
}

export const useGetLabSetupBySchoolIdQuery = (schoolId: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["schoolLabSetup", schoolId],
    enabled: Boolean(schoolId) && (options?.enabled ?? true),
    queryFn: async () => {
      const res = await axiosAuth.get<GetLabSetupResponse>(`${SCHOOL_LAB_SETUP_BY_SCHOOL_ID}${schoolId}/`);
      return res.data;
    },
  });
};
